const ROOT = `https://storage.googleapis.com/eleven-public-cdn/images/vo-studio`;

export const asset = `${ROOT}/vo-studio-hero.jpg`;

export const config = [
  {
    asset: `${ROOT}/vo-studio-narrator.png`,
  },
  {
    asset: `${ROOT}/vo-studio-timeline-narrator.png`,
  },
  {
    asset: `${ROOT}/vo-studio-sfx.png`,
  },
  {
    asset: `${ROOT}/vo-studio-timeline-sfx.png`,
  },
];
